import { create } from "zustand";
import {
  getQuestionsFilters,
  getAllQuestions,
  getAddNewQuestions,
  getDeleteQuestions,
  getEditQuestions,
  getReorderQuestions,
} from "../api/api";
import { toast } from "react-toastify";

export const useQaQuestions = create((set, get) => ({
  questionsData: [],
  questionsDataLoading: false,
  questionsDataError: null,
  questionsFilterData: [],
  questionsFilterDataLoading: false,
  questionsFilterDataError: null,
  newQuestionsAddedData: [],
  newQuestionsAddedDataLoading: false,
  newQuestionsAddedDataError: null,
  deleteQuestionsData: [],
  deleteQuestionsDataLoading: false,
  deleteQuestionsDataError: null,
  editQuestionsData: [],
  editQuestionsDataLoading: false,
  editQuestionsDataError: null,
  reorderQuestionsData: [],
  reorderQuestionsDataLoading: false,
  reorderQuestionsDataError: null,

  fetchQuestionsFilter: async () => {
    try {
      set({ questionsFilterDataLoading: true });
      const response = await getQuestionsFilters();
      set({ questionsFilterData: response?.data });
      toast.success(response?.data?.message);
    } catch (error) {
      set({ questionsFilterDataError: error?.response?.data?.message });
      toast.error(error?.response?.data?.message);
    } finally {
      set({ questionsFilterDataLoading: false });
    }
  },

  fetchQuestionsAfterFilterApply: async (params) => {
    try {
      set({ questionsDataLoading: true , questionsDataError: null, questionsData: [] });
      const response = await getAllQuestions(params);
      set({ questionsData: response?.data?.qaScoringFormInOrder  });  
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "An error occurred";
      set({ 
        questionsDataError: errorMessage,
        questionsData: [],
       });
      toast.error(errorMessage); 
    } finally {
      set({ questionsDataLoading: false });
    }
  },

  fetchAddNewQuestion: async (payload) => {
    try {
      set({ newQuestionsAddedDataLoading: true });
      const response = await getAddNewQuestions(payload);
      set({ newQuestionsAddedData: response.data });
      toast.success(response?.data?.message);
    } catch (error) {
      set({ newQuestionsAddedDataError: error?.response?.data?.message });
      toast.error(error?.response?.data?.message);
    } finally {
      set({ newQuestionsAddedDataLoading: false });
    }
  },

  fetchDeleteQuestion: async (id,data) => {
    try {
      set({ deleteQuestionsDataLoading: true });
      const response = await getDeleteQuestions(id,data);
      set({ deleteQuestionsData: response.data });
      toast.success(response?.data?.message);
    } catch (error) {
      set({ deleteQuestionsDataError: error?.response?.data?.message });
      toast.error(error?.response?.data?.message);
    } finally {
      set({ deleteQuestionsDataLoading: false });
    }
  },

  fetchEditQuestion: async (payload ,id) => {
    try {
      set({ editQuestionsDataLoading: true });
      const response = await getEditQuestions(payload,id);
      set({ editQuestionsData: response.data });
      toast.success(response?.data?.message);
    } catch (error) {
      set({ editQuestionsDataError: error?.response?.data?.message });
      toast.error(error?.response?.data?.message);
    } finally {
      set({ editQuestionsDataLoading: false });
    }
  },

  fetchReorderQuestion: async (payload) => {
    try {
      set({ reorderQuestionsDataLoading: true });
      const response = await getReorderQuestions(payload);
      set({ reorderQuestionsData: response.data });
      toast.success(response?.data?.message);
    } catch (error) {
      set({ reorderQuestionsDataError: error?.response?.data?.message });
      toast.error(error?.response?.data?.message);
    } finally {
      set({ reorderQuestionsDataLoading: false });
    }
  },
}));
